import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center justify-center md:justify-between bg-white border-b border-gray-200 flex py-4 pl-8" }
const _hoisted_2 = { class: "flex flex-col items-center md:flex-row justify-between" }
const _hoisted_3 = { class: "max-w-lg w-full md:w-56 lg:max-w-xs" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "search",
  class: "sr-only"
}, "Search", -1)
const _hoisted_5 = { class: "relative text-gray-400 focus-within:text-gray-600" }
const _hoisted_6 = { class: "pointer-events-none absolute inset-y-0 pl-3 left-0 flex items-center" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 pr-8" }
const _hoisted_9 = { class: "py-6" }
const _hoisted_10 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_11 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }
const _hoisted_12 = { class: "p-1 m-1 text-center" }
const _hoisted_13 = { class: "text-center" }

import { inject, onMounted, ref, watch } from "vue";
import "dayjs/locale/th";
import dayjs from "dayjs";
import stringify from "qs-stringify";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { AxiosInstance } from "axios";
import DialogComponent from "@/components/doalog/DialogComponent.vue";
import DataTable from "@/components/tools/DataTable.vue";
import Navbar from "@/components/tools/Navbar.vue";
import Pagination from "@/components/tools/Pagination.vue";
import GameRoundFilterDialog from "@/components/dialogs/GameRoundFilterDialog.vue";
import GameRoundDetailDialog from "@/components/dialogs/GameRoundDetailDialog.vue";
import { formatNumber, translate } from "@/utils/tools";

export default /*#__PURE__*/_defineComponent({
  __name: 'GameRounds',
  setup(__props) {

dayjs.extend(localizedFormat);

const SearchIcon = require("@heroicons/vue/solid/SearchIcon");

const axios = inject("$axios") as AxiosInstance;
const store = useStore();
const route = useRoute();
const dataRows = ref([]);
const isLoaded = ref(false);
const resettleData = ref({});
const selectedRow = ref({});
const advanceFilterModal = ref<boolean>(false);
const detailDialogModal = ref<boolean>(false);
const showErrorDetail = ref<boolean>(false);
const hasGameResult = ref<boolean>(false);
const errorMessage = ref<string>("");
const onSearch = (query: string) => {
  // console.log(query)
};
const providerList = ref([]);

const pageConfig = ref({
  page: route.query.page || 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  dataLength: 0,
  search: "",
  // isEmitOnClick: true,
  sort: [["created_at", "DESC"]],
});
const filterForm = ref({
  moduleCode: undefined,
  roundId: undefined,
  userAlias: undefined,
  userPhone: undefined,
  userId: undefined,
  createdAtFrom: undefined,
  createdAtTo: undefined,
  status: undefined,
  // from: null,
  // to: null,
});

const onResettle = (data: any) => {
  const { operatorId, providerCode: moduleCode, refCode2: roundId, userId } = data;
  axios
    .post(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/provider/game/force-settle`, data)
    .then(async (res) => {
      fetchPageData();
      resettleData.value = await axios
        .post(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/wallet/search-game-records`, {
          operatorId,
          moduleCode,
          roundId,
          userId,
        })
        .then((res) => res.data);
    })
    .catch((err) => {
      errorMessage.value = err.response.data.message;
      showErrorDetail.value = true;
      fetchPageData();
    });
};
const onCancelBet = async (data: any) => {
  if (confirm(`Are you sure you want to cancel bet this Round Id? (Round Id: ${data.refCode2})`)) {
    const { operatorId, moduleCode, refCode2: roundId, userId } = data;
    axios
      .post(process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/provider/game/force-cancel", data)
      .then(async (res) => {
        fetchPageData();
        resettleData.value = await axios
          .post(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/wallet/search-game-records`, {
            operatorId,
            moduleCode,
            roundId,
            userId,
          })
          .then((res) => res.data);
      })
      .catch((err) => {
        errorMessage.value = err.response.data.message || "ไม่สามารถ cancel bet ได้ เนื่องจากเคย cancel ไปแล้ว";
        showErrorDetail.value = true;
        fetchPageData();
      });
  }
};
//! TODO: use this default and create pagination
const moduleCodeRef = ref<string | undefined>();
const showDetailDialog = async (data: any, limit = 10, page = 1) => {
  const { moduleCode, userId, roundId, operatorId } = data;
  checkHasGameResult(moduleCode)
  detailDialogModal.value = true;
  selectedRow.value = data;
  moduleCodeRef.value = moduleCode;
  resettleData.value = await axios
    .post(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/wallet/search-game-records`, {
      operatorId,
      moduleCode,
      roundId,
      userId,
      limit,
      offset: (page - 1) * limit,
    })
    .then((res) => res.data);
};

const doSort = (attName: string) => {
  const index = columns.value.findIndex((column) => column.label === attName);

  columns.value[index].isSorted = !columns.value[index].isSorted;
  const { sort } = pageConfig.value;
  const mode = sort[0][1];
  if (attName === "Date Requested") attName = "requested_at";
  if (attName === "Date Approved") attName = "approve_at";
  if (attName === "Approved By") attName = "approve_by";
  if (attName === "Status") attName = "approve_status";
  sort[0] = [attName.toLowerCase(), mode === "DESC" ? "ASC" : "DESC"];
  fetchPageData(true);
};

const filterModal = (flag?: number) => {
  if (flag === 1) {
    fetchPageData(true);
  } else {
    fetchPageData(false);
  }
  advanceFilterModal.value = false;
  detailDialogModal.value = false;
};

const fetchPageData = async (reset = false) => {
  isLoaded.value = false;
  const { page, rowsPerPage, sort } = pageConfig.value;

  const { userId, userAlias, roundId, moduleCode, createdAtFrom, createdAtTo, userPhone, status } = filterForm.value;
  // let sort = [["created_at", "DESC"]]
  // let sort = sortBy.value.length ? sortBy.value : [["created_at", "DESC"]];
  let offset = (page - 1) * rowsPerPage;
  if (reset) {
    offset = 0;
    pageConfig.value.page = 1;
  }

  const payload: any = {
    operatorId: store.state.selectedOperator.operatorId,
    // page: page - 1,
    // pageSize: rowsPerPage,
    requestId: Date.now().toString(),
    requestTs: Date.now(),
    userId: userId === "" ? undefined : userId,
    userAlias: userAlias === "" ? undefined : userAlias,
    roundId: pageConfig.value.search ? pageConfig.value.search : roundId === "" ? undefined : roundId,
    moduleCode: moduleCode === "" || !moduleCode ? undefined : moduleCode.toUpperCase(),
    status: status === "" || !status ? undefined : status.toUpperCase(),
    userPhone: userPhone === "" ? undefined : userPhone,
    createdAtFrom: createdAtFrom,
    createdAtTo: createdAtTo,
    sortBy: sort[0][0].toLowerCase().split(" ").join("_"),
    sortDirection: sort[0][1],
    limit: rowsPerPage,
    offset: offset,
  };

  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/wallet/game-rounds`;
  const data = await axios.post(url, payload).then(({ data }) => data.result);

  pageConfig.value.dataLength = data.length;
  dataRows.value = data;

  pageConfig.value = {
    ...pageConfig.value,
    // count,
    // pageCount: Math.ceil(count / rowsPerPage),
  };
  /** update url to persist page config */
  window.history.replaceState({}, document.title, `?${stringify({ page, rowsPerPage })}`);
  isLoaded.value = true;
};

const getProviderList = async () => {
  try {
    const { data: providerLists } = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/provider/find-all`);
    providerList.value = providerLists.result
    return providerList.value
  } catch (err) {
    console.log(err)
  }
};

const checkHasGameResult = (moduleCode: string) => {
  const nonGameProviderCode = process.env.VUE_APP_NON_GAME_PROVIDER_MODULE_CODE?.split(",") || []
  const old_condition = nonGameProviderCode.includes(moduleCode.toLowerCase())
  if (old_condition) {
    hasGameResult.value = false
    return
  };

  const provider = providerList.value.find(p => (p as any).providerCode == moduleCode)
  hasGameResult.value = (provider as any).hasGameResult ? true : false
};

onMounted(() => {
  getProviderList();
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  fetchPageData();
});

const columns = ref([
  {
    label: translate("messages.gameRounds.username"),
    field: "userAlias",
    isSorted: false,
  },
  {
    label: translate("messages.gameRounds.roundId"),
    field: "roundId",
    isSorted: false,
  },
  {
    label: translate("messages.gameRounds.moduleCode"),
    field: "moduleCode",
    isSorted: false,
  },

  {
    label: translate("messages.gameRounds.betAmount"),
    field: "betAmount",
    sort: true,
    isSorted: true,
    format: (data: any) => formatNumber(data.betAmount),
    class: (data: any) => {
      if (Number(data.betAmount) < 0) return "text-red-500";
      return "text-green-500";
    },
  },

  {
    label: translate("messages.gameRounds.validBet"),
    field: "validAmount",
    sort: true,
    isSorted: true,
    format: (data: any) => (data.validAmount ? formatNumber(data.validAmount) : "-"),
    class: (data: any) => {
      if (Number(data.validAmount) < 0) return "text-red-500";
      return "text-green-500";
    },
  },

  {
    label: translate("messages.gameRounds.settleAmount"),
    field: "settleAmount",
    isSorted: false,
    sort: true,
    format: (data: any) => formatNumber(data.settleAmount),
    class: (data: any) => {
      if (Number(data.settleAmount) < 0) return "text-red-500";
      return "text-green-500";
    },
  },
  {
    label: translate("messages.gameRounds.cancelAmount"),
    field: "cancelAmount",
    isSorted: true,
    sort: true,
    format: (data: any) => formatNumber(data.cancelAmount),
    class: (data: any) => {
      if (Number(data.settleAmount) < 0) return "text-red-500";
      return "text-green-500";
    },
  },
  {
    label: translate("messages.gameRounds.withdrawAmount"),
    field: "withdrawAmount",
    isSorted: false,
    sort: true,
    format: (data: any) => formatNumber(data.withdrawAmount),
    class: (data: any) => {
      if (Number(data.withdrawAmount) < 0) return "text-red-500";
      return "text-green-500";
    },
  },
  {
    label: translate("messages.gameRounds.depositAmont"),
    field: "depositAmount",
    isSorted: false,
    sort: true,
    format: (data: any) => formatNumber(data.depositAmount),
    class: (data: any) => {
      if (Number(data.depositAmount) < 0) return "text-red-500";
      return "text-green-500";
    },
  },
  {
    label: translate("messages.gameRounds.winLoss"),
    field: "winLossAmount",
    // sort: true,
    isSorted: false,
    format: (data: any) => formatNumber(data.winLossAmount),
    class: (data: any) => {
      if (Number(data.winLossAmount) < 0) return "text-red-500";
      return "text-green-500";
    },
  },
  {
    label: translate("messages.gameRounds.openBalance"),
    field: "openBalance",
    isSorted: false,
    sort: true,
    format: (data: any) => formatNumber(data.openBalance),
    class: (data: any) => {
      if (Number(data.openBalance) < 0) return "text-red-500";
      return "text-green-500";
    },
  },
  {
    label: translate("messages.gameRounds.closeBalance"),
    field: "closedBalance",
    isSorted: false,
    sort: true,
    format: (data: any) => formatNumber(data.closedBalance),
    class: (data: any) => {
      if (Number(data.closedBalance) < 0) return "text-red-500";
      return "text-green-500";
    },
  },
  {
    label: translate("messages.gameRounds.status"),
    field: "status",
    isSorted: false,
  },
  {
    label: translate("messages.gameRounds.createdAt"),
    field: "createdAt",
    isSorted: false,
    // sort: true,
    format: (value: any) => {
      return value.createdAt ? dayjs(value.createdAt).format("YYYY-MM-DD HH:mm:ss") : "-";
    },
  },

  {
    label: translate("messages.gameRounds.viewGameResult"),
    field: "action",
    sort: false,
    isButton: true,
    isRow: true,
    buttonTitle: "View Details",
  },
]);

watch(
  () => pageConfig.value.page,
  () => fetchPageData()
);
/** fetch data when rows per page was changed */
watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = Number(route.query.page) || 1;
    fetchPageData();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar, {
      title: _ctx.$t('messages.gameRounds.gameRounds')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(SearchIcon), {
                class: "h-5 w-5",
                "aria-hidden": "true"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              id: "search",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageConfig.value.search) = $event)),
              class: "block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm",
              placeholder: _ctx.$t('messages.gameRounds.searchGameId'),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (fetchPageData(true))),
              type: "search",
              name: "search"
            }, null, 40, _hoisted_7), [
              [_vModelText, pageConfig.value.search]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (advanceFilterModal.value = true)),
            class: "ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
          }, [
            _createVNode(_component_font_awesome_icon, {
              class: "text-white mr-2",
              icon: ['far', 'filter'],
              transform: ""
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.gameRounds.advanceFilter")), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(DataTable, {
            columns: columns.value,
            data: dataRows.value,
            onSort: doSort,
            onShowDetailTable: showDetailDialog,
            isLoaded: isLoaded.value
          }, null, 8, ["columns", "data", "isLoaded"])
        ]),
        _createVNode(Pagination, {
          config: pageConfig.value,
          "onUpdate:config": _cache[3] || (_cache[3] = ($event: any) => ((pageConfig).value = $event))
        }, null, 8, ["config"])
      ])
    ]),
    _createVNode(GameRoundFilterDialog, {
      show: advanceFilterModal.value,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((advanceFilterModal).value = $event)),
      form: filterForm.value,
      "onUpdate:form": _cache[5] || (_cache[5] = ($event: any) => ((filterForm).value = $event)),
      onSubmit: filterModal
    }, null, 8, ["show", "form"]),
    _createVNode(GameRoundDetailDialog, {
      show: detailDialogModal.value,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((detailDialogModal).value = $event)),
      resettleData: resettleData.value,
      "module-code": moduleCodeRef.value,
      hasGameResult: hasGameResult.value,
      onSubmit: _cache[7] || (_cache[7] = ($event: any) => (filterModal(0))),
      onCancelBet: onCancelBet,
      onResettle: onResettle,
      onPageChange: _cache[8] || (_cache[8] = (e) => showDetailDialog(selectedRow.value, e.limit, e.page))
    }, null, 8, ["show", "resettleData", "module-code", "hasGameResult"]),
    _createVNode(DialogComponent, { isOpen: showErrorDetail.value }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, _toDisplayString(errorMessage.value), 1),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            class: "bg-red-500 rounded p-2 text-white",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (showErrorDetail.value = false))
          }, _toDisplayString(_ctx.$t("messages.gameRounds.close")), 1)
        ])
      ]),
      _: 1
    }, 8, ["isOpen"])
  ], 64))
}
}

})